import apiService from "@/../api/rest";
import storageMaintenance from "./storageMaintenance";

export const getDefaultState = () => {
  return {
    venueId: "",
    domainId: "",
    visitorSource: "VISITOR_SOURCE_INTERACT_WEB",
    iwToken: "",
    refreshToken: ""
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  getVenueId: function(state) {
    return state.venueId;
  },
  getDomainId: function(state) {
    return state.domainId;
  },
  getVisitorSource(state) {
    return state.visitorSource;
  },
  getIwToken(state) {
    return state.iwToken;
  },
  getRefreshToken(state) {
    return state.refreshToken;
  }
};

// actions
const actions = {
  resetAppState({ commit }) {
    commit("cart/resetState", null, { root: true });
    commit("cart/resetCheckoutState", null, { root: true });
    commit("cart/resetDiscountState", null, { root: true });
    commit("cart/resetOAPIState", null, { root: true });
    commit("common/resetState", null, { root: true });
    commit("config/resetState", null, { root: true });
    commit("dayParts/resetState", null, { root: true });
    commit("delivery/resetState", null, { root: true });
    commit("level/resetState", null, { root: true });
    commit("messages/resetState", null, { root: true });
    commit("orderAhead/resetState", null, { root: true });
    commit("payments/resetState", null, { root: true });
    commit("spinner/resetState", null, { root: true });
    commit("theme/resetState", null, { root: true });
    commit("user/resetState", null, { root: true });
    commit("user/resetFavoritesState", null, { root: true });
    commit("vendor/resetState", null, { root: true });
    commit("vendor/resetMenuItemsState", null, { root: true });
    commit("vendor/resetMenuItemsFilterState", null, { root: true });
    commit("venue/resetState", null, { root: true });
    commit("venueSettings/resetState", null, { root: true });
    commit("featureFlags/resetState", null, { root: true });
  },

  async authenticate({ commit }, venueId) {
    try {
      //initResponse type corresponds to AuthInitResponse interface
      const { data: initResponse } = await apiService.authInit(venueId);
      commit("setIwToken", initResponse.iwToken);
      commit("setRefreshToken", initResponse.iwRefreshToken);
      commit("setDomainId", initResponse.domainId);
    } catch (error) {
      commit("setIwToken", "");
      commit("setDomainId", "");
      return Promise.reject(error);
    }
  },

  async refreshIWToken({ commit }) {
    try {
      const response = await apiService.refreshIWToken();
      const { iwToken, iwRefreshToken } = response.data;
      if (iwToken && iwRefreshToken) {
        commit("setIwToken", iwToken);
        commit("setRefreshToken", iwRefreshToken);
      }
      return iwToken;
    } catch (error) {
      return null;
    }
  }
};

// mutations
const mutations = {
  setDomainId(state, domainId) {
    state.domainId = domainId;
  },
  setVenueId(state, id) {
    state.venueId = id;
  },
  setIwToken(state, iwToken) {
    state.iwToken = iwToken;
  },
  setRefreshToken(state, refreshToken) {
    state.refreshToken = refreshToken;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  modules: {
    storageMaintenance
  },
  state,
  getters,
  actions,
  mutations
};
